import {EventHandler} from "../EventDispatcher";
import DocumentDownload from "../../Entity/DocumentDownload";
import {IpcMainInvokeEvent} from "electron";
import getGetMediaDownloadToken from "../../DependencyInjection/getMediaDownloadToken";
import getDownloadManager from "../../DependencyInjection/downloadManager";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import {
    PartialDownloadCancelledResult,
    PartialDownloadController, PartialDownloadError,
    PartialDownloadProgress,
    PartialDownloadResult
} from "../../../../types/downloadManager";
import {
    FinishPartialProgressStrategy,
    PartialProgressStrategy,
    SlowPartialProgressStrategy,
    StarPartialProgressStrategy,
    UpdatePartialProgressStrategy
} from "../../Progress/PartialProgressStrategy";

const eventDispatcher = getEventDispatcher();
let documentDownload: DocumentDownload | null = null;
let partialController: PartialDownloadController;

async function onProgressReportPartial(progress: PartialDownloadProgress): Promise<void> {
    const strategies: PartialProgressStrategy[] = [
        new UpdatePartialProgressStrategy(),
        new SlowPartialProgressStrategy(),
        new StarPartialProgressStrategy(partialController),
        new FinishPartialProgressStrategy()
    ];

    for (const strategy of strategies) {
        if (strategy.isValid(progress)) {
            strategy.onProgress(progress);
        }
    }
}

function onPartDownloadComplete(info: { partialPosition: number; totalParts: number }): void {
    const part = info.partialPosition + 1;
    console.log(`Part ${part}/${info.totalParts} completed`);
}

async function finishMergePartialDownload(error: Error | null, filePath: string | null): Promise<void> {
    if (error) {
        console.warn('Error merging partial download:', error);
        await eventDispatcher.dispatch('FinishCurrentDownloadWithErrorAction', documentDownload);

        return;
    }

    console.log('Partial download merged successfully. File path:', filePath);

    await eventDispatcher.dispatch('FinishCurrentDownloadAction', documentDownload);
}

async function partialDownloadCallback(error: Error | null, result: PartialDownloadResult | PartialDownloadError | PartialDownloadCancelledResult): Promise<void> {
    const completed = (result as PartialDownloadResult).completed ?? false;
    if (null === error && completed) {
        getDownloadManager().mergePartialDownload({
            uuid: documentDownload?.getUuid() || '',
            fileSize: documentDownload?.getFilesize() || 0,
            partSize: documentDownload?.getFilesizeCalculateParts() || 0,
        }, finishMergePartialDownload);

        return;
    }

    const uuid: string = result.uuid;
    const url: string = (result as PartialDownloadError).url ?? '';

    console.warn('Error: Partial Download seems to have been interrupted for UUID: ', uuid);
    console.warn('Additional info with `error` object in onProgress callback');
    console.warn('error', error);
    console.warn('url', url);

    await eventDispatcher.dispatch('FinishCurrentDownloadWithErrorAction', documentDownload);
}

const PartialDownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    documentDownload = DocumentDownload.from(content);

    const token: string | null = await getGetMediaDownloadToken().get(
        documentDownload.getUuid(),
        documentDownload.getSessionToken()
    );
    if (null === token) {
        await eventDispatcher.dispatch('FinishCurrentDownloadWithErrorAction', documentDownload);
        return;
    }

    documentDownload.setToken(token);

    partialController = getDownloadManager().partialDownload({
        url: documentDownload.getUrlWithToken(),
        uuid: documentDownload.getUuid(),
        fileSize: documentDownload.getFilesize(),
        partSize: documentDownload.getFilesizeCalculateParts(),
        onProgress: onProgressReportPartial,
        onPartComplete: onPartDownloadComplete
    }, partialDownloadCallback);

    return;
}

export default PartialDownloadListener;